import React, {useContext, useState} from "react";
import {useHitsPerPage} from "react-instantsearch-hooks-web";
import ListboxSelect from "../Form/Select/ListboxSelect";
import {findKey} from "lodash";
import FilterContext from "../Context/FilterContext";

const HitsPerPage = props => {
    const {
        items,
        refine,
        createURL,
        hasNoResults,
    } = useHitsPerPage(props);

    const { setLoading } = useContext(FilterContext)

    const [value, setValue] = useState(items[findKey(items, item => item.default)])

    const handleChange = item => {
        if (setLoading) setLoading(true)
        refine(item.value)
    }

    return (
        <ListboxSelect items={items} handleChange={handleChange} value={value}/>
    )
}

export default HitsPerPage